
import { 
  ShoppingBag, Cpu, Shirt, Home as HomeIcon, Apple, 
  BookOpen, Paintbrush, Sparkles, Stethoscope, 
  Recycle, Building, GraduationCap, Coffee, UtensilsCrossed 
} from 'lucide-react';

export interface SubCategory {
  name: string;
  link: string;
}

export interface Category {
  id: string;
  name: string;
  icon: React.ElementType;
  subcategories: SubCategory[];
}

// Create a shared categories data source that can be used across the app
export const categoriesData: Category[] = [
  { 
    id: 'electronics',
    name: 'Electronics', 
    icon: Cpu,
    subcategories: [
      { name: 'Smartphones', link: '/search?category=electronics&subcategory=smartphones' },
      { name: 'Accessories', link: '/search?category=electronics&subcategory=accessories' }
    ]
  },
  { 
    id: 'fashion',
    name: 'Fashion', 
    icon: Shirt,
    subcategories: [
      { name: 'Women', link: '/search?category=fashion&subcategory=women' },
      { name: 'Men', link: '/search?category=fashion&subcategory=men' }
    ]
  },
  { 
    id: 'home-living',
    name: 'Home & Living', 
    icon: HomeIcon,
    subcategories: [
      { name: 'Furniture', link: '/search?category=home-living&subcategory=furniture' },
      { name: 'Decor', link: '/search?category=home-living&subcategory=decor' }
    ]
  },
  { 
    id: 'groceries',
    name: 'Groceries', 
    icon: Apple,
    subcategories: [
      { name: 'Fresh Food', link: '/search?category=groceries&subcategory=fresh-food' },
      { name: 'Packaged Food', link: '/search?category=groceries&subcategory=packaged-food' }
    ]
  },
  { 
    id: 'books',
    name: 'Books', 
    icon: BookOpen,
    subcategories: [
      { name: 'Fiction', link: '/search?category=books&subcategory=fiction' },
      { name: 'Non-Fiction', link: '/search?category=books&subcategory=non-fiction' }
    ]
  },
  { 
    id: 'local-crafts',
    name: 'Local Crafts', 
    icon: Paintbrush,
    subcategories: [
      { name: 'Baskets', link: '/search?category=local-crafts&subcategory=baskets' },
      { name: 'Wood Art', link: '/search?category=local-crafts&subcategory=wood-art' }
    ]
  },
  { 
    id: 'beauty-wellness',
    name: 'Beauty & Wellness', 
    icon: Sparkles,
    subcategories: [
      { name: 'Skincare', link: '/search?category=beauty-wellness&subcategory=skincare' },
      { name: 'Cosmetics', link: '/search?category=beauty-wellness&subcategory=cosmetics' }
    ]
  },
  { 
    id: 'health-wellness',
    name: 'Health & Wellness', 
    icon: Stethoscope,
    subcategories: [
      { name: 'Supplements', link: '/search?category=health-wellness&subcategory=supplements' },
      { name: 'Exercise Equipment', link: '/search?category=health-wellness&subcategory=exercise-equipment' }
    ]
  },
  { 
    id: 'second-hand',
    name: 'Second Hand', 
    icon: Recycle,
    subcategories: [
      { name: 'Electronics', link: '/search?category=second-hand&subcategory=electronics' },
      { name: 'Furniture', link: '/search?category=second-hand&subcategory=furniture' },
      { name: 'Clothing', link: '/search?category=second-hand&subcategory=clothing' }
    ]
  },
  { 
    id: 'construction',
    name: 'Construction', 
    icon: Building,
    subcategories: [
      { name: 'Tools', link: '/search?category=construction&subcategory=tools' },
      { name: 'Materials', link: '/search?category=construction&subcategory=materials' },
      { name: 'Hardware', link: '/search?category=construction&subcategory=hardware' }
    ]
  },
  { 
    id: 'school-materials',
    name: 'School Materials', 
    icon: GraduationCap,
    subcategories: [
      { name: 'Stationery', link: '/search?category=school-materials&subcategory=stationery' },
      { name: 'Textbooks', link: '/search?category=school-materials&subcategory=textbooks' },
      { name: 'Uniforms', link: '/search?category=school-materials&subcategory=uniforms' }
    ]
  },
  { 
    id: 'ahavex-food',
    name: 'Ahavex Food', 
    icon: UtensilsCrossed,
    subcategories: [
      { name: 'Ready Meals', link: '/search?category=ahavex-food&subcategory=ready-meals' },
      { name: 'Snacks', link: '/search?category=ahavex-food&subcategory=snacks' },
      { name: 'Beverages', link: '/search?category=ahavex-food&subcategory=beverages' }
    ]
  },
  { 
    id: 'made-in-rwanda',
    name: 'Made in Rwanda', 
    icon: ShoppingBag,
    subcategories: [
      { name: 'Handcrafts', link: '/search?category=made-in-rwanda&subcategory=handcrafts' },
      { name: 'Food Products', link: '/search?category=made-in-rwanda&subcategory=food-products' },
      { name: 'Clothing', link: '/search?category=made-in-rwanda&subcategory=clothing' },
      { name: 'Souvenirs', link: '/search?category=made-in-rwanda&subcategory=souvenirs' }
    ]
  }
];
